
// PAQUETES
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";

 
function WidgetWompi({ wompiConfig, className = "", textoCargando = "Cargando métodos de pago...", textoError = "No fue posible cargar Wompi. Intenta nuevamente.", mostrarEstado = true, alCargar, alError, }) {

  //console.log("wompiConfig: ", wompiConfig);
  // amountInCents : 6014600 
  // currency : "COP" 
  // customerEmail : "proyectos@eduardoarias.co" 
  // entorno : "LOCAL" 
  // integritySignature : "f444c7f1fc65da30ac4963a43fcc3d3634fff5f0579b9c9e58136c3c4c67351d" 
  // publicKey : "pub_test_N0LHla4wG65dSUUGCz8voPfHjCyNcNsw" 
  // reference : "RESERVA_69b64c3829195b5a9eee1fe4" 
  // urlEntorno : "http://localhost:3001"
  // redirectUrl: "http://localhost:3001/respuesta-pago/"



  // useref: guarda una referencia que no proboca rerender
  const contenedorRef = useRef(null); // guarda el <div> real del DOM donde se va a meter el script de Wompi.
  const scriptRef     = useRef(null); // guarda el <script> que se crea dinámicamente
  const timeoutRef    = useRef(null); // guarda el id del setTimeout para luego poder limpiarlo con clearTimeout.

  const [cargando, setCargando] = useState(false);
  const [error, setError]       = useState("");

  const configNormalizada = useMemo(() => {
    if (!wompiConfig) return null;

    return {
      amountInCents: wompiConfig.amountInCents,
      currency: wompiConfig.currency || "COP",
      customerEmail: wompiConfig.customerEmail || "",
      // entorno no está aqui, pero si viene en wompiConfig
      signature: wompiConfig.integritySignature || "",
      publicKey: wompiConfig.publicKey || "",
      reference: wompiConfig.reference || "",
      redirectUrl: wompiConfig.redirectUrl || "", // lo ponemos pero realmente obtenemos el resultado de la transacción con webhooks.
      // de aqui abajo no son necesarios para el pago.
      expirationTime: wompiConfig.expirationTime || "",
      taxInCents: wompiConfig.taxInCents || null,
      shippingAddress: wompiConfig.shippingAddress || null,
      installments: wompiConfig.installments || null,
      extraAttributes: wompiConfig.extraAttributes || {},
    };
  }, [wompiConfig]);

  
  
  useEffect(() => {
    const contenedor = contenedorRef.current; // current apunta al nodo real del DOM.

    if (!contenedor) return undefined;

    contenedor.innerHTML = "";
    setError("");

    if (!configNormalizada) return undefined;

    const {
      amountInCents,
      currency,
      customerEmail,
      // entorno no está aqui, pero si viene en wompiConfig
      signature,
      publicKey,
      reference,
      redirectUrl,
      // de aqui abajo no son necesarios para el pago.
      expirationTime,
      taxInCents,
      shippingAddress,
      installments,
      extraAttributes,
    } = configNormalizada;

    if (!publicKey || !amountInCents || !reference || !signature) {
      const mensaje = "Faltan datos obligatorios para renderizar el widget de Wompi.";
      setError(mensaje);
      if (typeof alError === "function") alError(mensaje);
      return undefined;
    }

    setCargando(true);


    // paso 1:  creamos un elemento script (vacío) dinámicamente. Devuelve un nodo del DOM, un objeto tipo elemento HTML, que luego se puede configurar.
    const script = document.createElement("script"); 
    // paso 2: ponemos src al script y dsatos
    script.src   = "https://checkout.wompi.co/widget.js";
    script.async = true;
    // DATOS NECESARIOS PARA LA TRANSACCIÓNB
    script.setAttribute("data-render", "button");
    script.setAttribute("data-public-key", publicKey);
    script.setAttribute("data-currency", currency);
    script.setAttribute("data-amount-in-cents", String(amountInCents));
    script.setAttribute("data-reference", reference);
    script.setAttribute("data-signature:integrity", signature);

    // OPCIONALES Y QUE NO TENEMOS
    if (redirectUrl) { script.setAttribute("data-redirect-url", redirectUrl); }
    if (customerEmail) { script.setAttribute("data-customer-data:email", customerEmail); }
    if (expirationTime) { script.setAttribute("data-expiration-time", expirationTime); }

    if (taxInCents && typeof taxInCents === "object") {
      Object.entries(taxInCents).forEach(([clave, valor]) => {
        if (valor !== undefined && valor !== null && valor !== "") {
          script.setAttribute(`data-tax-in-cents:${clave}`, String(valor));
        }
      });
    }

    if (shippingAddress && typeof shippingAddress === "object") {
      Object.entries(shippingAddress).forEach(([clave, valor]) => {
        if (valor !== undefined && valor !== null && valor !== "") {
          script.setAttribute(`data-shipping-address:${clave}`, String(valor));
        }
      });
    }

    if (installments) { script.setAttribute("data-installments", String(installments)); }

    if (extraAttributes && typeof extraAttributes === "object") {
      Object.entries(extraAttributes).forEach(([clave, valor]) => {
        if (valor !== undefined && valor !== null && valor !== "") {
          script.setAttribute(clave, String(valor));
        }
      });
    }


    // paso 3: registramos onload y onerror
    // cuando el navegador termine de descargar y ejecutar ese script externo, corre esta función.
    script.onload = () => {
      setCargando(false);
      setError("");
      if (typeof alCargar === "function") alCargar();
    };

    script.onerror = () => {
      const mensaje = "No fue posible cargar el script del widget de Wompi.";
      setCargando(false);
      setError(mensaje);
      if (typeof alError === "function") alError(mensaje);
    };


    // dentro de 6 segundos, ejecutamos el setcargando false: porque, solo pueden pasar 2 cosas al despliegar el script: onload, o onerror. 
    // pero aveces puede tener otras razones, o tardar demasiado. Este timeout impide que el usuario vea el "Cargando metodos.." eternamiente.
    // IMPORTANTE: se guarda en ref para poder limpiarlo luego.
    timeoutRef.current = window.setTimeout(() => {
      setCargando(false);
    }, 6000);

    // 4. metemos el script al DOM con appendChild
    contenedor.appendChild(script);
    scriptRef.current = script;





    // limpieza: cuando se desmonta el componente o cambia la dependencia configNormalizada
    return () => {
      if (timeoutRef.current) { window.clearTimeout(timeoutRef.current); }

      if (scriptRef.current && scriptRef.current.parentNode) { scriptRef.current.parentNode.removeChild(scriptRef.current); }

      contenedor.innerHTML = "";
    };
  }, [configNormalizada, alCargar, alError]);







  return (
    <div className={className}>
    
      {mostrarEstado && cargando && !error ? ( <div className="small text-muted mb-2">{textoCargando}</div> ) : null}

      {mostrarEstado && error ? ( <div className="small text-danger mb-2">{textoError}</div> ) : null}

      <div ref={contenedorRef} />
    </div>
  );
}

export default WidgetWompi;